@let theme = preset();
<button
  type="button"
  class="preset-tile"
  [class.is-selected]="selected()"
  [attr.aria-pressed]="selected()"
  [attr.aria-label]="theme.name | translate"
  (click)="picked.emit()">
  <span class="preset-art" aria-hidden="true">
    @for (mode of modes; track mode) {
      @let variant = theme[mode];
      <span
        class="preset-half"
        [class.art-light]="mode === 'light'"
        [class.art-dark]="mode === 'dark'"
        [style.--tile-primary]="variant.primary"
        [style.--tile-accent]="variant.accent">
        @if (variant.wallpaper) {
          <!-- Saved wallpapers come from the app server; COEP needs a CORS load. -->
          <img [src]="variant.wallpaper" alt="" draggable="false" crossorigin="anonymous" />
        }
        <span class="mini-room">
          <span class="mini-header">
            <i></i>
            <i></i>
            <i></i>
          </span>
          <span class="mini-door"></span>
          <span class="mini-people">
            <i></i>
            <i></i>
          </span>
          <span class="mini-controls">
            <i></i>
            <i></i>
            <i></i>
          </span>
        </span>
      </span>
    }
    <span class="preview-mode preview-mode--light">
      <fa-icon [icon]="faSunBright" />
    </span>
    <span class="preview-mode preview-mode--dark">
      <fa-icon [icon]="faMoonStars" />
    </span>
  </span>
  <span class="preset-caption">
    <span>{{ theme.name | translate }}</span>
    <span class="selection-mark" aria-hidden="true">
      @if (selected()) {
        <fa-icon [icon]="faCheck" />
      }
    </span>
  </span>
</button>
